import { __assign, __makeTemplateObject, __read } from "tslib";
import React, { useState } from 'react';
import { Button } from '../Button';
import { stylesFactory, useTheme } from '../../themes';
import { css } from 'emotion';
import { HorizontalGroup } from '..';
var getStyles = stylesFactory(function (theme) { return ({
    scale: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    font-size: ", ";\n    color: ", ";\n  "], ["\n    font-size: ", ";\n    color: ", ";\n  "])), theme.typography.size.sm, theme.colors.textFaint),
    scrollHelp: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    font-size: ", ";\n    color: ", ";\n  "], ["\n    font-size: ", ";\n    color: ", ";\n  "])), theme.typography.size.xs, theme.colors.textFaint),
}); });
/**
 * Control buttons for zoom but also some layout config inputs mainly for debugging.
 */
export function ViewControls(props) {
    var config = props.config, onConfigChange = props.onConfigChange, onPlus = props.onPlus, onMinus = props.onMinus, scale = props.scale, disableZoomOut = props.disableZoomOut, disableZoomIn = props.disableZoomIn;
    var _a = __read(useState(false), 2), showConfig = _a[0], setShowConfig = _a[1];
    var styles = getStyles(useTheme());
    // For debugging the layout, should be removed here and maybe moved to panel config later on
    var allowConfiguration = false;
    return (React.createElement(React.Fragment, null,
        React.createElement(HorizontalGroup, { spacing: "xs" },
            React.createElement(Button, { icon: 'plus-circle', onClick: onPlus, size: 'sm', title: 'Zoom in', variant: "secondary", disabled: disableZoomIn }),
            React.createElement(Button, { icon: 'minus-circle', onClick: onMinus, size: 'sm', title: 'Zoom out', variant: "secondary", disabled: disableZoomOut }),
            React.createElement("span", { className: styles.scale, title: 'Zoom level' },
                ' ',
                scale.toFixed(2),
                "x")),
        React.createElement("div", { className: styles.scrollHelp }, "Or ctrl/meta + scroll"),
        allowConfiguration && (React.createElement(Button, { size: 'xs', variant: 'link', onClick: function () { return setShowConfig(function (showConfig) { return !showConfig; }); } }, showConfig ? 'Hide config' : 'Show config')),
        allowConfiguration &&
            showConfig &&
            Object.keys(config)
                .filter(function (k) { return k !== 'show'; })
                .map(function (k) { return (React.createElement("div", { key: k },
                k,
                React.createElement("input", { style: { width: 50 }, type: 'number', value: config[k], onChange: function (e) {
                        var _a;
                        onConfigChange(__assign(__assign({}, config), (_a = {}, _a[k] = parseFloat(e.target.value), _a)));
                    } }))); })));
}
var templateObject_1, templateObject_2;
//# sourceMappingURL=ViewControls.js.map